var map = {
	"./afb-color.svg": 641,
	"./alb-color.svg": 642,
	"./all.svg": 643,
	"./amb-color.svg": 644,
	"./arg.svg": 645,
	"./aus.svg": 646,
	"./bank-icon.svg": 647,
	"./bankdemo-color.svg": 648,
	"./bel.svg": 649,
	"./bimb-color.svg": 650,
	"./bkr-color.svg": 651,
	"./bpay-color.svg": 652,
	"./bra.svg": 653,
	"./bsn-color.svg": 654,
	"./can.svg": 655,
	"./checked-blue.webp": 1632,
	"./checked-green.png": 656,
	"./checked-white.png": 657,
	"./cimb-color.svg": 658,
	"./cimb-icon.svg": 659,
	"./citi-color.svg": 660,
	"./cmr.svg": 661,
	"./crc.svg": 662,
	"./cro.svg": 663,
	"./den.svg": 664,
	"./ecu.svg": 665,
	"./eng.svg": 666,
	"./esp.svg": 667,
	"./fav-blue.svg": 668,
	"./fav-blue.webp": 1633,
	"./fav-gray.png": 669,
	"./fav-gray.svg": 670,
	"./fav-gray.webp": 1634,
	"./fav-icon-active.png": 671,
	"./fav-icon.png": 672,
	"./fav-red.png": 673,
	"./fra.svg": 674,
	"./game-icon.svg": 675,
	"./games-active-m.svg": 676,
	"./games-m.webp": 1635,
	"./ger.svg": 677,
	"./gha.svg": 678,
	"./gxbank-color.svg": 679,
	"./hlb-color.svg": 680,
	"./hlb-icon.svg": 681,
	"./hsbc-color.svg": 682,
	"./irn.svg": 683,
	"./jpn.svg": 684,
	"./kor.svg": 685,
	"./ksa.svg": 686,
	"./kwh-color.svg": 687,
	"./latest-icon-active.png": 688,
	"./latest-icon.png": 689,
	"./lc-active-m.svg": 690,
	"./lc-icon.svg": 691,
	"./lc-m.webp": 1636,
	"./lottery-active-m.svg": 692,
	"./lottery-icon.svg": 693,
	"./lottery-m.svg": 694,
	"./love.svg": 695,
	"./mar.svg": 696,
	"./mbb-color.svg": 697,
	"./mex.svg": 698,
	"./ned.svg": 699,
	"./ocbc-color.svg": 700,
	"./ocbc-icon.svg": 701,
	"./p2p-active-m.svg": 702,
	"./p2p-icon.svg": 703,
	"./p2p-m.svg": 704,
	"./pbb-color.svg": 705,
	"./pol.svg": 706,
	"./por.svg": 707,
	"./price-high.svg": 708,
	"./price-low.svg": 709,
	"./qat.svg": 710,
	"./rhb-color.svg": 711,
	"./rhb-icon.svg": 712,
	"./scb-color.svg": 713,
	"./sen.svg": 714,
	"./slot-active-m.svg": 715,
	"./slot-icon.svg": 716,
	"./slot-m.webp": 1637,
	"./sport-active-m.svg": 717,
	"./sport-m.webp": 1638,
	"./sports-icon.svg": 718,
	"./srb.svg": 719,
	"./star.svg": 720,
	"./sui.svg": 721,
	"./tng-color.svg": 722,
	"./trx-icon.svg": 723,
	"./trx.svg": 724,
	"./tun.svg": 725,
	"./uob-color.svg": 726,
	"./uru.svg": 727,
	"./usa.svg": 728,
	"./usdc.svg": 729,
	"./usdt.svg": 730,
	"./ustd-icon.svg": 731,
	"./wal.svg": 732,
	"./x33-logo-b.svg": 733,
	"./x33-square-icon.svg": 734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;